import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const ProductLabelTemplatesPage = lazy(
  () => import("../../../../components/WMS/Labels/ProductLabelTemplatesPage"),
)

export const Route = createFileRoute("/_layout/WMS/products/label-templates")({
  component: ProductLabelTemplatesRoute,
})

function ProductLabelTemplatesRoute() {
  return (
    <LazyRoutePage>
      <ProductLabelTemplatesPage />
    </LazyRoutePage>
  )
}
